<template>
    <div id="editTable">
        <vxe-table
                stripe
                highlight-hover-row
                border
                resizable
                :data.sync="tableData"
                ref="editTable"
        >
            <template v-slot:empty>
                <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
            </template>
            <template>
                <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                <template v-for="(item, index) in cols">
                    <vxe-table-column
                            show-header-overflow
                            show-overflow
                            :key="index"
                            width="350"
                    >
                        <template v-slot:header="{ column }">
                            {{ item.title }}
                        </template>
                        <template v-slot="{ row }">
                            <span>
                                <a-input :placeholder="$t('publicLang.PleaseEnter')" v-model="row[item.label].value" size="small"/>
                            </span>
                        </template>
                    </vxe-table-column>
                </template>
            </template>
        </vxe-table>
        <button @click="saveEditTable">{{ $t('publicLang.Save') }}</button>
    </div>
</template>
<script>
 export default{
     props:{
         cols: {
             type: Array,
             default: function() {
                 return [];
             }
         },
         tableData: {
             type: Array,
             default: function () {
                 return [];
             }
         }
     },
     data(){
         return{

         }
     },
     methods:{
         saveEditTable(){
             console.log(this.tableData);
         }
     }
 }
</script>
<style lang="less">
    #editTable{

    }
</style>